<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
.dialog {
}  
.dialog_title {
  font-size: 20px;
  margin-bottom: 20px;
}
button.el-button--primary {
  background-color: black !important;
  border-color: black !important;
}
button.el-button--primary:hover{
  background-color: rgb(75, 75, 75) !important;
  border-color: rgb(75, 75, 75) !important;
}
button.el-button--primary:active,button.el-button--primary:visited{
  background-color: black !important;
  border-color: black !important;
}
  .el-input__inner:focus {
  border-color: black !important; /* 修改为你需要的颜色 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue